import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import { getAuthToken, getUserFromToken, clearAuth } from '../context/authContext';
import { AuthContext } from '../context/authContext.jsx';
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

const HomePage = () => {
  const navigate = useNavigate();
  const {isAuthenticated} = useContext(AuthContext)

  useEffect(() => {
    // Check if user is already logged in
    // Primero intentar obtener desde las cookies usando la utilidad
    const userFromToken = getUserFromToken();
    if (userFromToken) {
      // Valid token from cookie - redirect to appropriate dashboard
      if (userFromToken.role === 'admin' || userFromToken.role === 'operator' || userFromToken.role === 'superadmin') {
        navigate('/admin/dashboard');
      } else if (userFromToken.role === 'technician') {
        navigate('/tecnico/dashboard');
      }
      return;
    }
    
    // Fallback al método anterior para compatibilidad
    const token = getAuthToken() ;
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        
        if (decoded.exp && decoded.exp > currentTime) {
          // Valid token - redirect to appropriate dashboard
          if (decoded.role === 'admin' || decoded.role === 'operator' || decoded.role === 'superadmin') {
            navigate('/admin/dashboard');
          } else if (decoded.role === 'technician') {
            navigate('/tecnico/dashboard');
          }
        } else {
          // Expired token - remove it
          clearAuth();
        }
      } catch (e) {
        // Invalid token - remove it
        clearAuth();
      }
    }
  }, [navigate]);

  if (!isAuthenticated) {
    return (
      <div className="container">
            <Navigate to="/admin/login" replace/>
      </div>
    )
  }
};

export default HomePage; 